import { Typography } from '@mui/material';
import { Spacer } from '@sparemin/blockhead';
import { EpisodeMetrics } from 'api';
import GoBackButton from 'components/NavigatableHeader/GoBackButton';
import TableCells from 'components/TableCells';
import React from 'react';

type PlaysDashboardTitleProps = {
  episodeDetails: Omit<EpisodeMetrics, 'playCount'> | undefined;
  onGoBack?: () => void;
};

const PlaysDashboardTitle: React.FC<PlaysDashboardTitleProps> = ({
  episodeDetails,
  onGoBack,
}) => {
  if (episodeDetails?.remoteEpisodeId) {
    return (
      <Spacer orientation="vertical" space={1}>
        <GoBackButton onClick={onGoBack}>return to all episodes</GoBackButton>
        <TableCells.EnhancedPodcastEpisodeCell
          thumbnailUrl={episodeDetails.thumbnailUrl}
          episodeTitle={episodeDetails.title}
          pubDateInMillis={episodeDetails.publishedAtMillis}
          durationMillis={episodeDetails.durationMillis}
        />
      </Spacer>
    );
  }
  return <Typography variant="h3">Total plays during this period</Typography>;
};
export default PlaysDashboardTitle;
